import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ClientPermissionsDataType } from '../types'
const initialState: ClientPermissionsDataType = {
  programPermissions: {},
  hasViewPermission: true,
  programs: {},
  permissionServices: {},
  programServices: {},
  permissionNameIdMapping: [],
  globalPermissions: {},
}

const clientPermissionsSlice = createSlice({
  name: 'clientPermissions',
  initialState: initialState,
  reducers: {
    getPermissionByTenantId: (state: ClientPermissionsDataType, _action) => {
      return state
    },
    updateClientPermissionState: (
      state,
      action: PayloadAction<ClientPermissionsDataType>
    ) => {
      state.programPermissions = action.payload.programPermissions
      state.globalPermissions = action.payload.globalPermissions
      state.hasViewPermission = action.payload.hasViewPermission
      state.programs = action.payload.programs
      state.permissionServices = action.payload.permissionServices
      state.programServices = action.payload.programServices
      state.permissionNameIdMapping = action.payload.permissionNameIdMapping
    },
  },
})

export const { getPermissionByTenantId, updateClientPermissionState } =
  clientPermissionsSlice.actions
export default clientPermissionsSlice.reducer
